<template>
  <div class="container bg-white h-100">
    <nav class="navbar navbar-light bg-white">
      <a class="navbar-brand" href="#">
        <img v-if="settings.logoUrl" :src="settings.logoUrl" class="img-fluid brand"
          :alt="settings.companyName" />
        <span v-else>{{ settings.companyName }}</span>
      </a>
    </nav>
    <div class="jumbotron jumbotron-fluid d-flex flex-column justify-content-center flex-md-row align-items-center h-75">
      <div>
        <h1 class="title">Inactive Affiliate</h1>
        <p class="description">We’re sorry, but it seems this partnership is no longer active. Please reach out to the person who
          gave you this link for assistance.</p>
      </div>
      <img src="../assets/no-marketing-affilliate.png" class="mx-5 img img-fluid" alt="Inactive Marketting" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-inactive-card',
  props: {
    settings: {},
  },
};
</script>
<style lang="scss">
.navbar {
  height: 110px;
  display: flex;
  align-items: center;
}

.navbar a img {
  width: 100px;
}

.jumbotron {
  img {
    max-width: 350px;
    max-height: 249px;
  }

  .title {
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
  }

  .description {
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
  }
}

</style>
